export const CUSTOMER_ME_REQUESTED = "CUSTOMER_ME_REQUESTED";
export const CUSTOMER_ME_RECEIVED = "CUSTOMER_ME_RECEIVED";
export const CUSTOMER_ME_REQUEST_FAILED = "CUSTOMER_ME_REQUEST_FAILED";
export const CUSTOMER_ME_PATCH_REQUEST_RESET = "CUSTOMER_ME_PATCH_REQUEST_RESET";

export const CUSTOMER_ME_PATCH_REQUESTED = "CUSTOMER_ME_PATCH_REQUESTED";
export const CUSTOMER_ME_PATCH_RECEIVED = "CUSTOMER_ME_PATCH_RECEIVED";
export const CUSTOMER_ME_PATCH_REQUEST_FAILED = "CUSTOMER_ME_PATCH_REQUEST_FAILED";

export const requestCustomerMe = () => ({ type: CUSTOMER_ME_REQUESTED });
export const receiveCustomerMe = customer => ({ type: CUSTOMER_ME_RECEIVED, payload: customer });

export const requestUpdateCustomerMe = customer => ({ type: CUSTOMER_ME_PATCH_REQUESTED, payload: customer });
export const receiveUpdateCustomerMe = customer => ({ type: CUSTOMER_ME_PATCH_RECEIVED, payload: customer });
export const resetUpdateCustomerMe = () => ({ type: CUSTOMER_ME_PATCH_REQUEST_RESET });
